import React, { useState } from "react";
import { ArrowRight, Check, Copy, Mail } from "lucide-react";

function EmailPill() {
	const [copied, setCopied] = useState(false);

	function handleCopy(e) {
		e.preventDefault();
		navigator.clipboard.writeText("promotejobs@dproz.com");
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	}

	return (
		<div className="flex flex-col items-center gap-4">
			<a
				href="mailto:promotejobs@dproz.com?subject=Job%20Posting%20Request"
				className="inline-flex items-center gap-2.5 bg-white text-blue-900 rounded-full px-7 py-3.5 font-inter text-[15px] font-semibold hover:bg-blue-50 transition-colors shadow-lg shadow-blue-950/20"
			>
				<Mail className="w-[18px] h-[18px]" />
				Send a Job via Email
				<ArrowRight className="w-4 h-4" />
			</a>
			<button
				onClick={handleCopy}
				className="inline-flex items-center gap-2 font-inter text-sm text-white/70 hover:text-white/90 transition-colors cursor-pointer"
			>
				<span>promotejobs@dproz.com</span>
				{copied ? <Check className="w-3.5 h-3.5 text-green-400" /> : <Copy className="w-3.5 h-3.5" />}
			</button>
		</div>
	);
}

export default EmailPill;
